module.exports = __webpack_public_path__ + "static/media/home_button.31dbeb76.png";